export const COMPASS_CIRCLE_DISPLAY_SIZE = 210;
export const COMPASS_CIRCLE_EXPORT_SIZE = 420;

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.crossOrigin = "anonymous";
    image.src = url;
  });

export const getCroppedImg = async (
  imageSrc,
  pixelCrop,
  outputSize = COMPASS_CIRCLE_EXPORT_SIZE,
) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = outputSize;
  canvas.height = outputSize;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, outputSize, outputSize);

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputSize,
    outputSize,
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Could not crop photo."));
          return;
        }
        resolve(blob);
      },
      "image/jpeg",
      0.92,
    );
  });
};

export const resolveUploadedPhotoUrl = (data) => {
  if (!data) return null;
  if (typeof data === "string") return data;
  return (
    data.croppedHeadshotURL ||
    data.optimizedPhotoURL ||
    data.photoURL ||
    data.url ||
    data.path ||
    (data.data && data.data !== data
      ? resolveUploadedPhotoUrl(data.data)
      : null)
  );
};
